<form [formGroup]="barrierForm" (ngSubmit)="onSubmit()" class="create-barrier-form">
    @if (isProcessing) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <div class="form-section">
        <h3 class="section-title">Basic Information</h3>
        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Barrier Name</mat-label>
                <input matInput formControlName="deviceName" placeholder="e.g., Entry Barrier">
                <mat-icon matSuffix>meeting_room</mat-icon>
                @if (barrierForm.get('deviceName')?.hasError('required')) {
                <mat-error>
                    Barrier name is required
                </mat-error>
                }
                @if (barrierForm.get('deviceName')?.hasError('minlength')) {
                <mat-error>
                    Barrier name must be at least 2 characters
                </mat-error>
                }
            </mat-form-field>
        </div>

        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Device Hardware ID</mat-label>
                <input matInput formControlName="deviceHardwareID" placeholder="Leave empty to auto-generate">
                <mat-icon matSuffix>memory</mat-icon>
                <mat-icon matPrefix class="generate-icon" (click)="generateGUID()" title="Generate new GUID">
                    auto_awesome
                </mat-icon>
            </mat-form-field>
        </div>

        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Device Description</mat-label>
                <textarea matInput formControlName="deviceDescription" placeholder="Optional description"
                    rows="2"></textarea>
                <mat-icon matSuffix>note</mat-icon>
            </mat-form-field>
        </div>

        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Master Controller</mat-label>
                <mat-select formControlName="masterControllerId" placeholder="Select a master controller (optional)">
                    <mat-option [value]="null">None</mat-option>
                    @for ( controller of masterControllers(); track controller.masterDeviceId) {
                    <mat-option [value]="controller.masterDeviceId">
                        {{ controller.masterDevice?.deviceName || 'Unnamed Controller' }}
                        @if (controller.masterDevice?.deviceHardwareID) {
                        <span class="text-gray-500">
                            ({{ controller.masterDevice?.deviceHardwareID }})
                        </span>
                        }
                    </mat-option>
                    }
                </mat-select>
                <mat-icon matSuffix>settings_input_component</mat-icon>
                @if (isLoadingMasterControllers()) {
                <mat-hint>Loading master controllers...</mat-hint>
                }
                @if (!isLoadingMasterControllers() && masterControllers().length === 0 && parkingSpaceId) {
                <mat-hint>
                    No master controllers available for this parking space
                </mat-hint>
                }
            </mat-form-field>
        </div>
    </div>

    <div class="form-section" formGroupName="config">
        <h3 class="section-title">Barrier Configuration</h3>
        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Base URL</mat-label>
                <input matInput formControlName="baseUrl" placeholder="https://barrier.local">
                <mat-icon matSuffix>link</mat-icon>
                @if (barrierForm.get('config.baseUrl')?.hasError('required')) {
                <mat-error>
                    Base URL is required
                </mat-error>
                }
            </mat-form-field>
        </div>

        <button type="button" mat-button (click)="toggleAdvanced()" class="toggle-advanced">
            <mat-icon>{{ showAdvanced() ? 'expand_less' : 'expand_more' }}</mat-icon>
            <span>{{ showAdvanced() ? 'Hide' : 'Show' }} Advanced Settings</span>
        </button>

        @if (showAdvanced()) {
        <div class="advanced-settings">
            <div class="form-row-two">
                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Open Path</mat-label>
                    <input matInput formControlName="openPath" placeholder="/open">
                </mat-form-field>
                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Close Path</mat-label>
                    <input matInput formControlName="closePath" placeholder="/close">
                </mat-form-field>
            </div>

            <div class="form-row-two">
                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Open Pulse Path</mat-label>
                    <input matInput formControlName="openPulsePath" placeholder="/open-pulse">
                </mat-form-field>
                <mat-form-field appearance="fill" class="half-width">
                    <mat-label>Toggle Relay Path</mat-label>
                    <input matInput formControlName="toggleRelayPath" placeholder="/toggle-relay">
                </mat-form-field>
            </div>
        </div>
        }
    </div>

    <div class="form-actions">
        <button mat-stroked-button (click)="onCancel()" type="button" [disabled]="isProcessing">
            <mat-icon>close</mat-icon>
            Cancel
        </button>
        <button mat-raised-button color="primary" type="submit" [disabled]="isProcessing || !barrierForm.valid">
            <mat-icon>{{ isProcessing ? 'hourglass_empty' : 'check' }}</mat-icon>
            {{ isProcessing ? (mode === 'edit' ? 'Updating...' : 'Creating...') : (mode === 'edit' ? 'Update Barrier' :
            'Create Barrier') }}
        </button>
    </div>
</form>